import { lazy } from "react";
import { Navigate } from "react-router";

import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import RoleProtected from "../components/RoleProtected.jsx";
import { UserType } from "store/constant.js";

// Dashboard
const Dashboard = Loadable(lazy(() => import("views/dashboard/Default")));

// Orders
const AllOrders = Loadable(lazy(() => import("views/orders/AllOrders")));
const OrdersByCategory = Loadable(lazy(() => import("views/orders/OrdersByCategory")));
const FirstConsultations = Loadable(lazy(() => import("views/orders/FirstConsultations.js")));

// Utilities
const ChangePassword = Loadable(
  lazy(() => import("views/utilities/ChangePassword/ChangePassword"))
);

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    // Dashboard
    {
      path: "dashboard",
      element: (
        <RoleProtected allowedRoles={[UserType.Admin]}>
          <Dashboard />
        </RoleProtected>
      ),
    },

    // Orders
    {
      path: "orders",
      element: (
        <RoleProtected allowedRoles={[UserType.Admin]}>
          <AllOrders />
        </RoleProtected>
      ),
    },
    {
      path: "orders/category/:categorySlug",
      element: (
        <RoleProtected allowedRoles={[UserType.Admin]}>
          <OrdersByCategory />
        </RoleProtected>
      ),
    },
    {
      path: "orders/consult-an-expert",
      element: (
        <RoleProtected allowedRoles={[UserType.Admin]}>
          <FirstConsultations />
        </RoleProtected>
      ),
    },

    // Utilities
    {
      path: "change-password",
      element: (
        <RoleProtected allowedRoles={[UserType.Admin]}>
          <ChangePassword />
        </RoleProtected>
      ),
    },

    // Fallback
    {
      path: "*",
      element: localStorage.getItem("token") ? (
        <Navigate to="/dashboard" replace />
      ) : (
        <Navigate to="/login" replace />
      ),
    },
  ],
};

export default MainRoutes;
